import React, { useState } from "react"
import { ChevronLeft, LogOut } from "react-feather"
import { useHistory } from "react-router-dom"
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap"
import styles from "./ContentWrapper.module.scss"

function ContentWrapper({ children, addBack, logout = true, spectate }) {
	const history = useHistory()
	const [isOpen, setIsOpen] = useState(false)

	const onLogout = () => {
		const skin = localStorage.getItem("skin")
		const shouldPinPlayers = localStorage.getItem("shouldPinPlayers")
		localStorage.clear()
		localStorage.setItem("skin", skin)
		localStorage.setItem("shouldPinPlayers", shouldPinPlayers)
		history.push("/")
	}

	const onBack = () => {
		if (history.action !== "POP") {
			history.goBack()
		} else {
			history.push("/")
		}
	}

	return (
		<div
			className={`${styles.wrapper} ${
				children.length > 1 ? "" : styles.center
			}`}
		>
			{!spectate && addBack && (
				<div className={styles.back}>
					<Button.Ripple
						className={"btn-icon rounded-circle"}
						outline
						size="sm"
						color="primary"
						onClick={onBack}
					>
						<ChevronLeft />
					</Button.Ripple>
				</div>
			)}
			{!spectate && logout && (
				<div className={styles.logout}>
					<Button.Ripple
						className={"btn-icon rounded-circle"}
						outline
						size="sm"
						color="primary"
						onClick={() => setIsOpen(true)}
					>
						<LogOut />
					</Button.Ripple>
				</div>
			)}
			<Modal
				isOpen={isOpen}
				toggle={() => setIsOpen(false)}
				className="modal-dialog-centered modal-sm"
			>
				<ModalHeader toggle={() => setIsOpen(false)}>Log out</ModalHeader>
				<ModalBody className={styles.popup}>
					Jesi li siguran da želiš izaći iz svog accounta?
				</ModalBody>
				<ModalFooter>
					<Button.Ripple outline color="primary" onClick={onLogout}>
						Izađi
					</Button.Ripple>
					{!spectate && (
						<Button.Ripple
							color="secondary"
							onClick={() => setIsOpen(false)}
						>
							Odustani
						</Button.Ripple>
					)}
				</ModalFooter>
			</Modal>

			{children}
		</div>
	)
}

export default ContentWrapper
